import { render, staticRenderFns } from "./AdminDashCoupons.vue?vue&type=template&id=5e679c73&scoped=true"
import script from "./AdminDashCoupons.vue?vue&type=script&lang=js"
export * from "./AdminDashCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e679c73",
  null
  
)

export default component.exports